import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from 'react-i18next';

import '../css/LineChartComponent.css';

const LineChartComponent = ({ filteredResults, labels, colors }) => {
  const { t } = useTranslation();
  const [hiddenLines, setHiddenLines] = useState({}); // {label: true/false}

    const data = filteredResults
    .slice() // copie
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    .map((result) => {
        const obj = { date: new Date(result.createdAt).getTime() };
        let sum = 0;
        let count = 0;
        result.answers.forEach((val, i) => {
          obj[labels[i].labelRight] = val;
          if (typeof val === 'number') {
            sum += val;
            count++;
          }
        });
        if (count > 0) {
          obj['Average'] = parseFloat((sum / count).toFixed(2));
        }
        return obj;
    });

  const handleLegendClick = (e) => {
    const { dataKey } = e;
    setHiddenLines((prev) => ({ ...prev, [dataKey]: !prev[dataKey] }));
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}>
          <p className="label" style={{ margin: 0, fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>
            {new Date(label).toLocaleDateString("fr-FR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })}
          </p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.dataKey === 'Average' ? '#555555' : entry.color, margin: '2px 0', fontSize: '0.9rem' }}>
              {entry.name} : <span style={{ fontWeight: 'bold' }}>{entry.value}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="line-chart-container">
        <div className="line-chart-responsive">
            <div className="responsive-line-wrapper">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={data} margin={{ top: 30, right: 0, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis
                        dataKey="date"
                        tickFormatter={(value) =>
                            new Date(value).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" })
                        }
                        type="number"
                        domain={["auto", "auto"]}
                        scale="time"
                        />
                    <YAxis
                        type="number"
                        domain={[1, 10]}  // de 0 à 10
                        allowDecimals={true} // ou false si tu veux que ce soit des entiers
                        />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend verticalAlign="top" align="left" height={50} onClick={handleLegendClick} />
                    {labels.map((label, index) => (
                        <Line
                        key={index}
                        type="monotone"
                        dataKey={label.labelRight}
                        stroke={colors[index % colors.length]}
                        dot={{ r: 2 }} 
                        activeDot={{ r: 4 }}
                        strokeWidth={2}
                        connectNulls
                        hide={hiddenLines[label.labelRight]}
                        />
                    ))}
                    <Line
                        type="monotone"
                        dataKey="Average"
                        name={t("stats.line.average", "Moyenne")}
                        stroke="#ffffff"
                        dot={{ r: 3, fill: "#ffffff" }}
                        activeDot={{ r: 5 }}
                        strokeWidth={4}
                        connectNulls
                        hide={hiddenLines['Average']}
                    />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    </div>
  );
};

export default LineChartComponent;